import React, { useState, useEffect , useRef } from 'react';
import styled from 'styled-components';

function IterativeRadioList({ ListName, IterativeData, DefaultValue, DisabledValues, OnSelectChange }) {

  // State to manage the checked status of the radio buttons
  const [checkedOption, setCheckedOption] = useState(DefaultValue); // Set Option 1 as checked initially

  useEffect(()=>{
    setCheckedOption(DefaultValue);
  },[DefaultValue])

  // Function to handle radio button change
  const handleRadioChange = (e) => {
    setCheckedOption(e.target.value); // Update the checked option based on user selection
    OnSelectChange(e)
  };

  const isItemDisabled = (item) => {
    let result = DisabledValues.includes(item);
    return result;
  };

  return (
    <Wrapper className='rblist' >
      {IterativeData.map(item => (
        <div key={item.id}>
          <input
            type="radio"
            id={`${item.id}`}
            name={ListName}
            checked={checkedOption === item.id}
            value={item.id}
            disabled = {isItemDisabled(item.id)}
            onChange={handleRadioChange} />
          <label htmlFor={item.id}>{item.label}</label>
        </div>
      ))}
    </Wrapper>
  )
}

export default IterativeRadioList;


const Wrapper = styled.div`
border-radius : var(--radius);
display: flex;
flex-direction: row;
-webkit-box-pack: justify;
justify-content: space-between;
    div {   
      width:100%;   
        label {
            width:100%;   
            color: var(--clr-neutral-1);
            border-color :var(--clr-neutral-1);
            font-style:normal;           
            border:1px solid;
            border-right:0px;
            border-radius: 2px;
            display: inline-block;
            height: fit-content;
            text-align:center;            
            line-height: 26px;
            margin: 2px;
            padding: 5px;
            transition: .2s all ease-in-out;
            cursor:pointer;
            &:hover{
                color :var(--clr-neutral-1);
            }
        }
        input[type="radio"] {
        display: none;
        }
        input[type="radio"]:checked + label {
            background: var(--clr-primary-5);
            border: 1px solid $form-border-color;
            &:hover{
                color :var(--clr-neutral-1);
            }
        }
        input[type="radio"]:disabled + label {
            background: var(--clr-grey-7);
            border: 1px solid $form-border-color;
            &:hover{
                cursor:not-allowed;
            }
        }
        &:last-child label{
         border-right: 1px solid black; /* Specify the width, style, and color */
          }
    }
`